import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext({ lang: "it", setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "it";
    return window.localStorage.getItem("rosablu_lang") || "it";
  });

  useEffect(() => {
    try {
      window.localStorage.setItem("rosablu_lang", lang);
    } catch (e) {
      // ignore storage errors
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return ctx;
};
